import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const PdfPageSelectionModal = ({open,file,loading,onClose,onSave}) => {

  const [numPages, setNumPages] = useState(0);
  const [selectedPages, setSelectedPages] = useState([]);
  useEffect(() => {
  if (open) {
    setSelectedPages([]);
    setNumPages(0);
  }
}, [open, file]);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const togglePage = (pageNumber) => {
    if (selectedPages.includes(pageNumber)) {
      setSelectedPages(
        selectedPages.filter((page) => page !== pageNumber)
      );
    } else {
      setSelectedPages([
        ...selectedPages,
        pageNumber,
      ]);
    }
  };

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,.5)",
        overflow: "auto",
        zIndex: 9999,
      }}
    >
      <div 
        style={{
          background: "#fff",
          width: "80%",
          margin: "30px auto",
          padding: 20,
          borderRadius: 8,
        }}
      >
        <div className="flex" style={{justifyContent: "space-between"}}>
          <h5>Select PDF Pages</h5>
          <button style={{background:  "transparent"}} onClick={onClose}>
            ✕
          </button>
        </div>
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <p>Loading PDF...</p>
          </div>
          ) : (
          <Document
            file={file}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(error) => { console.error("PDF load error:", error);
            toast.error("Unable to load PDF.");
            }}
          >
          {Array.from(
            new Array(numPages),
            (_, index) => (
              <div
                key={index}
                style={{
                  display: "inline-block",
                  margin: 15,
                  textAlign: "center",
                }}
              >
              <label className="mb-20">
                <input
                  type="checkbox"
                  checked={selectedPages.includes(index + 1)}
                  onChange={() => togglePage(index + 1)}
                />
                <span style={{ marginLeft: "8px" }}>
                  Page {index + 1}
                </span>
              </label>
                <Page pageNumber={index + 1} width={280}/>
              </div>
            )
          )}
        </Document>

)}

        <br />
        <div className="flex">      
          <button  className='btn btn-default' onClick={onClose} style={{ marginLeft: 10}}>
            Cancel
          </button>
          <button className='btn btn-default' type="button" onClick={() => onSave(selectedPages)}>
            Continue
          </button>
        </div>

      </div>
    </div>
  );
};

export default PdfPageSelectionModal;